import { Action, createReducer, on } from '@ngrx/store'

import * as AGGREGATION_ANALYSIS_ACTIONS from './aggregation-analysis.actions'
import { createAggregationAnalysisInitState, IAggregationAnalysisState } from './aggregation-analysis.state'

export const aggregationAnalysisState = createReducer(
  createAggregationAnalysisInitState(),

  // quarter
  on(AGGREGATION_ANALYSIS_ACTIONS.getAggregationAnalysisQuarterData, state => ({
    ...state,
    quarter: {
      ...state.quarter,
      inRequest: true,
    },
  })),

  on(AGGREGATION_ANALYSIS_ACTIONS.setAggregationAnalysisQuarterSuccess, (state, { data, aggType }) => ({
    ...state,
    quarter: {
      ...state.quarter,
      initialized: true,
      inRequest: false,
      error: undefined,
      data,
      aggType,
    },
  })),
  on(AGGREGATION_ANALYSIS_ACTIONS.setAggregationAnalysisQuarterError, (state, { error }) => ({
    ...state,
    quarter: {
      ...state.quarter,
      initialized: true,
      inRequest: false,
      error,
    },
  })),

  on(AGGREGATION_ANALYSIS_ACTIONS.setAggregationAnalysisQuarterSelected, (state, { selected }) => ({
    ...state,
    quarter: {
      ...state.quarter,
      selected,
    },
  })),

  // sector
  on(AGGREGATION_ANALYSIS_ACTIONS.getAggregationAnalysisSectorData, state => ({
    ...state,
    sector: {
      ...state.sector,
      inRequest: true,
    },
  })),

  on(AGGREGATION_ANALYSIS_ACTIONS.setAggregationAnalysisSectorSuccess, (state, { data, aggType, quarter }) => ({
    ...state,
    sector: {
      ...state.sector,
      initialized: true,
      inRequest: false,
      error: undefined,
      data,
      aggType,
      quarter,
    },
  })),

  on(AGGREGATION_ANALYSIS_ACTIONS.setAggregationAnalysisSectorError, (state, { error }) => ({
    ...state,
    sector: {
      ...state.sector,
      initialized: true,
      inRequest: false,
      error,
    },
  })),

  on(AGGREGATION_ANALYSIS_ACTIONS.setAggregationAnalysisSectorSort, (state, { sortBy, order }) => ({
    ...state,
    sector: {
      ...state.sector,
      initialized: false,
      sortBy,
      order,
    },
  })),

  // aggregation type
  on(AGGREGATION_ANALYSIS_ACTIONS.setAggregationAnalysisType, (state, { aggType }) => ({
    ...state,
    aggType,
  }))
)

export const aggregationAnalysisReducer = (
  state: IAggregationAnalysisState,
  action: Action
): IAggregationAnalysisState => aggregationAnalysisState(state, action)
